<div class="d-flex align-items-center justify-content-center">
  <div *ngIf="order">
    <div [class]="getIconClasses()"></div>
  </div>

  <div *ngIf="order; else noorder" [class]="getContainerClasses()">
    <ng-container *ngIf="brandHandoffs$ | async as brandHandoffs">
      <div [class]="getHeaderClasses()">
        <ng-container [ngSwitch]="order.handoffType">
          <div *ngSwitchCase="handoffs.pickup" class="handoff-overline">
            <div>
              <ng-container *ngIf="handoffs.pickup | handoffLabel | async as pickupLabel">
                {{ pickupLabel || 'Pickup' }}
              </ng-container>
              From
            </div>
          </div>
          <div *ngSwitchCase="handoffs.driveThru" class="handoff-overline">
            <div>
              <ng-container *ngIf="handoffs.driveThru | handoffLabel | async as driveThruLabel">
                {{ driveThruLabel || 'Drive Thru Pickup' }}
              </ng-container>
              From
            </div>
          </div>
          <div *ngSwitchCase="handoffs.curbside" class="handoff-overline">
            <div>
              <ng-container *ngIf="handoffs.curbside | handoffLabel | async as curbsideLabel">
                {{ curbsideLabel || 'Curbside Pickup' }}
              </ng-container>
              From
            </div>
          </div>
          <div *ngSwitchCase="handoffs.delivery" class="handoff-overline">
            <div>
              <ng-container *ngIf="handoffs.delivery | handoffLabel | async as deliveryLabel">
                {{ deliveryLabel || 'Delivering' }}
              </ng-container>
              To
            </div>
          </div>
          <div *ngSwitchCase="handoffs.dispatch" class="handoff-overline">
            <div>
              <ng-container *ngIf="handoffs.dispatch | handoffLabel | async as dispatchLabel">
                {{ dispatchLabel || 'Delivering' }}
              </ng-container>
              To
            </div>
          </div>
          <div *ngSwitchDefault class="handoff-overline">
            <div>
              <ng-container *ngIf="handoffs.dispatch | handoffLabel | async as defaultLabel">
                {{ defaultLabel || 'Delivering' }}
              </ng-container>
              To
            </div>
          </div>
        </ng-container>
      </div>
      <div class="text-nowrap d-flex justify-content-center">
        <span class="fw-bold font-size-body-small d-inline-block align-middle text-truncate">
          <ng-container [ngSwitch]="order.handoffType">
            <ng-container *ngSwitchCase="handoffs.pickup">
              {{ order.location.name | filterBrandNameFromLocation: filterTags | truncate: 20 }}
            </ng-container>
            <ng-container *ngSwitchCase="handoffs.curbside">
              {{ order.location.name | filterBrandNameFromLocation: filterTags | truncate: 20 }}
            </ng-container>
            <ng-container *ngSwitchCase="handoffs.driveThru">
              {{ order.location.name | filterBrandNameFromLocation: filterTags | truncate: 20 }}
            </ng-container>
            <ng-container *ngSwitchCase="handoffs.delivery">
              {{ order.deliveryAddress?.address1 | truncate: 20 }}
            </ng-container>
            <ng-container *ngSwitchCase="handoffs.dispatch">
              {{ order.deliveryAddress?.address1 | truncate: 20 }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ order.deliveryAddress?.address1 | truncate: 20 }}
            </ng-container>
          </ng-container>
        </span>
        <div
          class="bi bi-chevron-down d-inline-block align-middle ps-1"
          [ngStyle]="{
            color: (app$ | async).navbarSettings?.mobile_icon_color,
          }"></div>
      </div>
    </ng-container>
  </div>
</div>
<ng-template #noorder>
  <div [class]="getContainerClasses()">
    <span class="fw-bold fs-16 d-inline-block align-middle text-truncate">
      <u> Start New Order </u>
    </span>
    <div
      class="bi bi-chevron-down d-inline-block align-middle ps-1"
      [ngStyle]="{
        color: (app$ | async).navbarSettings?.mobile_icon_color,
      }"></div>
  </div>
</ng-template>
